import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Sole24OreRequest } from 'src/app/common/models/sole-24-ore-request';
import { TipologicaSole24Ore } from 'src/app/common/models/tipologiche-sole-24-ore';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { OperationsService } from 'src/app/core/services/operations.service';
//import { DettaglioSole24OreComponent } from '../modale-dettaglio-sole-24-ore/dettaglio-sole24-ore.component';
;

@Component({
  selector: 'app-sole24-ore',
  templateUrl: './sole24-ore.component.html',
  styleUrls: ['./sole24-ore.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class Sole24OreComponent implements OnInit {
  @Input() tipoFascicolo: string;
  @Input() tipoPratica: string;
  @Input() idFascicolo: string;

  //mapping fonti
  fonti: any = [{
    "codice": "1",
    "descrizione": "Legge",
    "query": "\"idfontedocumentale\":1"
    },
    {
    "codice": "2",
    "descrizione": "Prassi",
    "query": "\"idfontedocumentale\":2"
    },
    {
    "codice": "3",
    "descrizione": "Giurisprudenza",
    "query": "\"idfontedocumentale\":3"
  }];

  testoLibero: string;
  flagLegge: boolean = false;
  flagPrassi: boolean = false;
  flagGiurisprudenza: boolean = false;
  formSole24Ore: FormGroup;
  request: Sole24OreRequest;
  ambitiOptions: TipologicaSole24Ore[] = [];
  organoOptions: TipologicaSole24Ore[] = [];
  ambitoSlezionato: any = null;
  organoSelezionato: any = null;
  bisSelezionato: any = null;
  provvedimentoSelezionato: any = null;
  bisOptions: any = [];
  provvedimentoOptions: TipologicaSole24Ore[] = [];
  sole24OreResponse: any = null;
  today = new Date().getTime();
  subscriptionSalvataggio: Subscription;
  text1: string = '';
  text2: string = '';
  content: string = '';


  //@ViewChild('dettaglioModal') dettagglioModal: DettaglioSole24OreComponent;

  constructor(private ops: OperationsService, private form: FormBuilder, private modalNotifyService: ModalNotifyService){

  }


  ngOnInit() {
    this.createForm();
    this.ops.getRequestSole24Ore(this.tipoPratica, this.tipoFascicolo, this.idFascicolo).subscribe(res => {
      if(res && res.request){
        this.request = res.request;
        this.changeStato(this.request.fonte, true);
        this.sole24OreResponse =  res;
      }
    })
  }


  inizializza(){
  }

  createForm(){
    if(!this.request){
      this.request = new Sole24OreRequest();
    }
    this.formSole24Ore = this.form.group({
      organo: [this.request.organo],
      ambito: [this.request.ambito],
      dataDal:[this.request.dataDa],
      dataA: [this.request.dataA],
      numero: [this.request.numero],
      articolo: [this.request.articolo],
      bis: [this.request.bis],
      provvedimento: [this.request.provvedimento],
    })
  }

  changeStato(fonte?,isRequest = false){
    let pathFonte;
    if(fonte){
        if(fonte === '1'){
          if(!isRequest) this.request = new Sole24OreRequest();
          //this.flagGiurisprudenza = false;
          //this.flagPrassi = false;
          //this.flagLegge = true;
          pathFonte = 'legge';
        }else if( fonte === '2'){
          if(!isRequest) this.request = new Sole24OreRequest();
          //this.flagGiurisprudenza = false;
          //this.flagLegge = false;
          //this.flagPrassi = true;
          pathFonte = 'prassi';
        }else if (fonte === '3') {
          if(!isRequest) this.request = new Sole24OreRequest();
          //this.flagLegge = false
          //this.flagPrassi = false;
          //this.flagGiurisprudenza = true;
          pathFonte = 'giurisprudenza';
          this.getTipologiche('organo_giurisprudenza')
        }else {
          this.request.fonte = null;
        }
        this.getTipologiche('tipoprovvedimento_'+pathFonte);
        this.request.fonte = fonte;
      }else {
        this.request.fonte = null;
      }
  }

  getTipologiche(nodo: string){
    this.ops.getTipologicheSole24Ore(nodo, this.tipoPratica, this.tipoFascicolo).subscribe(res => {
      if(res && res.data.length > 0){
        if(nodo.includes('tipoprovvedimento_'))
          this.provvedimentoOptions = res.data;
        else this.organoOptions = res.data;
      }
    })
  }

  cerca(){
    this.ops.sole24OreSearch(this.tipoPratica, this.tipoFascicolo, this.idFascicolo, this.request).subscribe(res => {
      this.sole24OreResponse = res;
    })
  }

  reloadSearch() {
    this.request.fromResult = this.sole24OreResponse.documents.length;
    this.ops.sole24OreSearch(this.tipoPratica, this.tipoFascicolo, this.idFascicolo, this.request).subscribe(response => this.processBancheDati(response, false));
  }

  processBancheDati(response, emptyList){
    if(emptyList) {
      this.sole24OreResponse.documenti = [];
      this.sole24OreResponse = response;
    }
    else {
      this.sole24OreResponse.documents = this.sole24OreResponse.documents.concat(response.documents);
      this.sole24OreResponse.totalDocument = response.totalDocument;
    }
  }

  importDoc(idDoc: string){
    this.subscriptionSalvataggio = this.modalNotifyService.notifyConfirmObservable.subscribe(result => this.eseguiImport(idDoc, result));
    this.modalNotifyService.notifyIMportSole24Ore();
  }

  eseguiImport(idDoc: string, result: any){
    if(result){
      this.ops.importDocSole24Ore(this.tipoPratica, this.tipoFascicolo, this.idFascicolo, idDoc).subscribe(res => {
        if(res){
          this.subscriptionSalvataggio.unsubscribe();
          this.modalNotifyService.genericSuccessMessage();
        }
      })
    }else{
      this.subscriptionSalvataggio.unsubscribe();
    }
  }

  reset(){
    this.flagGiurisprudenza = false;
    this.flagLegge = false;
    this.flagPrassi = false;
    this.organoOptions = [];
    this.provvedimentoOptions = [];
    this.sole24OreResponse = null;
    this.request = new Sole24OreRequest();
    this.createForm();
  }

  getDocumentoHtml(idDocumento, element){ //per non eseguire la chiamata ad ogni click controllo se l'accordion non è stato ancora aperto
    if(!element.className.includes(' in')){
      this.text1 = '';
      this.text2 = '';
      this.content = '';
      this.ops.getDocumentoHtmlSole24Ore(this.tipoPratica, this.tipoFascicolo, idDocumento).subscribe(res => {
        if(res){
          this.text1 = res.document.text1;
          this.text2 = res.document.text2;
          this.content = res.document.content;
          //console.log(this.documentoHtml)
        }
      })
    }
  }

  change(el){
    console.log(el, this.request)
    this.request.provvedimento = el;
  }

}
